import {AfterViewInit, Component, inject, OnInit} from '@angular/core';
import {CmsApiService} from '../../core/cms-api.service';
import {AConst} from '../../core/a-const.enum';
import {FaqLoader} from './faqloader';
import {PrimusStateMapperService} from '../../core/primus-state-mapper.service';
import {PrimusRouterService} from '../../core/primus-router.service';
import {OperationService} from '../../operations/operation.service';
import {OperationContainer} from '../../core/definitions/operation-container';
import {OperationTarget} from '../../core/definitions/operation-target.enum';
import {OperationDef} from '../../core/definitions/operation-def';
import {ObjectPageNavigationStack} from '../../object-page-v2/object-page-navigation-stack';

@Component({
    selector: 'app-admin-main-page',
    templateUrl: './admin-main-page.component.html',
    styleUrls: ['./admin-main-page.component.scss'],
    standalone: false
})
export class AdminMainPageComponent implements OnInit, AfterViewInit {
  // Injections
  readonly primusStateMapper: PrimusStateMapperService = inject(PrimusStateMapperService);
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly objectPageNavigationStack: ObjectPageNavigationStack = inject(ObjectPageNavigationStack);
  private readonly operationService: OperationService = inject(OperationService);
  private readonly primusRouter: PrimusRouterService = inject(PrimusRouterService);

  AConst = AConst;
  parent;
  adminFq = [];
  visibleFq = {};
  operationContainer: OperationContainer;
  adminOperation: OperationDef;

  ngOnInit() {
    this.parent = {
      adminType: 'admin',
      hasSubMenus: false,
      currentState: this.primusRouter.currentState()
    };
  }

  ngAfterViewInit() {
    this.getMenus().then();
  }

  toggleFq(index) {
    this.visibleFq[index] = !this.visibleFq[index];
  }

  private async getMenus() {
    this.operationContainer = await this.operationService.createOperationContainer(OperationTarget.MAIN_MENU_VIEW);
    await this.operationService.setOperations(this.operationContainer);
    if (this.operationContainer.operations) {
      const faqLoader = new FaqLoader(this.operationContainer.operations, this.cms);
      const faqData = await faqLoader.getFAQData();
      faqData.forEach(f => {
        f.faq.forEach(fq => {
          this.adminFq.push(fq);
        });
      });
      this.setAdminOperations();
    }
  }

  private setAdminOperations() {
    this.operationContainer.operations.forEach(operation => {
      const menuType = operation.menu_category;
      if (menuType === 'admin') {
        this.adminOperation = operation;
      }
    });
  }
}
